import type { FilterDefinition } from "@/shared/components/ResourceView";
import {
  eventLabel,
  ManagedByKind,
  SUBSCRIBABLE_EVENT_TYPES,
  TARGET_TYPE_LABELS,
  TriggerTargetType,
  type TriggerFilterField,
  type TriggerFiresOn,
  type TriggerOwner,
} from "@/shared/domain/triggers";

/** The filter widget's definitions for the triggers list, one per field it can filter on. */
export const TRIGGER_FILTER_DEFINITIONS = [
  {
    type: "string",
    field: "trigger_id",
    name: "Trigger ID",
    allowedComparators: ["CONTAINS", "EQUALS"],
  },
  {
    type: "string",
    field: "name",
    name: "Name",
    allowedComparators: ["CONTAINS", "EQUALS"],
  },
  {
    type: "enum",
    field: "fires_on",
    name: "Fires on",
    options: [
      { value: "events", label: "Platform events" },
      { value: "schedule", label: "Schedule" },
    ] satisfies { value: TriggerFiresOn; label: string }[],
  },
  {
    type: "set",
    field: "events",
    name: "Platform event",
    options: SUBSCRIBABLE_EVENT_TYPES.map((eventType) => ({
      value: eventType,
      label: eventLabel(eventType),
    })),
  },
  {
    type: "set",
    field: "targets",
    name: "Target type",
    options: Object.values(TriggerTargetType).map((type) => ({
      value: type,
      label: TARGET_TYPE_LABELS[type],
    })),
  },
  {
    type: "enum",
    field: "managed_by",
    name: "Managed by",
    options: [
      { value: ManagedByKind.System, label: "Roboto" },
      { value: ManagedByKind.IngestionRule, label: "Ingestion rule" },
      { value: "user", label: "User" },
    ] satisfies { value: TriggerOwner; label: string }[],
  },
  { type: "boolean", field: "enabled", name: "Enabled" },
  {
    type: "string",
    field: "modified_by",
    name: "Modified by",
    allowedComparators: ["CONTAINS", "EQUALS"],
  },
] satisfies (FilterDefinition & { field: TriggerFilterField })[];
